import smartSolveApi from './instances/smartsolve';

export const getSavedSearchDetails = async (params) => {
  try {
    const response = await smartSolveApi.post('/savedsearch/open', params);
    return response.data;
  } catch (e) {
    throw new Error(`getSavedSearchDetails() failed: ${e}`);
  }
};

export const getSavedSearchExists = async (params) => {
  try {
    const response = await smartSolveApi.post('/savedsearch/exists', params);
    return response.data;
  } catch (e) {
    throw new Error(`getSavedSearchExists() failed: ${e}`);
  }
};

export const saveSavedSearch = async (params) => {
  try {
    const response = await smartSolveApi.post('/savedsearch/save', params);
    return response.data;
  } catch (e) {
    throw new Error(`saveSavedSearch() failed: ${e}`);
  }
};

export const deleteSavedSearch = async (params) => {
  try {
    const response = await smartSolveApi.post('/savedsearch/delete', params);
    return response.data;
  } catch (e) {
    throw new Error(`deleteSavedSearch() failed: ${e}`);
  }
};
